var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#FFE4D2",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2703 13.9952L19.9983 21.3451C20.1707 21.1983 20.407 20.9973 20.6938 20.7536C21.3253 20.217 22.2019 19.4731 23.1823 18.6436C24.9696 17.1315 27.1039 15.3336 28.7268 13.9903C28.3796 13.3978 27.7363 13 27 13H13C12.2617 13 11.6168 13.4001 11.2703 13.9952ZM29 15.0627C27.4353 16.362 25.4844 18.0058 23.8282 19.4071C23.5077 19.6782 23.1983 19.9402 22.905 20.1888L28.9636 25.3819C28.9875 25.2583 29 25.1306 29 25V15.0627ZM28.5107 26.3107L22.1746 20.8799L22.4 20.6169C22.0013 20.9551 21.6433 21.2591 21.3414 21.5157C21.0258 21.7838 20.7715 22.0001 20.5961 22.1494L20.3944 22.3211L20.3421 22.3657L20.3288 22.377L20.3254 22.3799L20.3246 22.3806L20.3244 22.3807L20 22.0002L20.3243 22.3808L20.0019 22.6555L19.678 22.3827L17.6492 20.6742L17.8254 20.8799L11.4894 26.3108C11.8561 26.733 12.3968 27 13 27H27C27.6032 27 28.144 26.733 28.5107 26.3107ZM11.0364 25.3819L17.084 20.1983L11 15.0749V25C11 25.1306 11.0125 25.2583 11.0364 25.3819Z",
    fill: "#FF5C01"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#FF5C01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationMessage);
export default __webpack_public_path__ + "static/media/icon_notification_message.c9ce7f3dbebbc909913e8e1300255cc7.svg";
export { ForwardRef as ReactComponent };